// @flow

import React, {useCallback, useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import Section from './Section';

import sizeChartAddIcon from '../../../../../assets/img/product-page/size-chart-add.svg';
import {
  // Chip,
  Divider,
  // FormControlLabel,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';

// import IosSwitch from '../../../../../elements/IosSwitch/IosSwitch';
import CustomButton from '../../../../../elements/CustomButton/CustomButton';
import {colors} from '../../../../../assets/styles/colors';

import AddNewSizeGuideModal from '../Modals/AddNewSizeGuideModal';
import SnackBar from '../../../../../elements/SnackBar/SnackBar';
import SizeChartItem from '../GuideSizeContent/SizeChartItem/SizeChartItem';
import {useIsFeatureInTier} from '../../../../../utils/component';

import type {ProductPageSettingRequest} from '../../api';
import type {RootState} from '../../../..';
import type {ProductPageSetting, SizeChart} from '../../duck';
import type {Theme} from '@material-ui/core';

type Props = {
  disabled?: boolean,
  productPageSetting?: ProductPageSetting,
  saveProductPageSetting: ({
    productPageSettingRequest: ProductPageSettingRequest,
  }) => void,
};

const useStyles = makeStyles((theme: Theme) => ({
  label: {
    fontWeight: 'normal',
    fontSize: '14px',
    color: colors.grey700,
  },

  divider: {
    backgroundColor: colors.grey300,
    margin: theme.spacing(2, 0),
  },
  button: {
    border: `1px solid ${colors.grey300}`,
    padding: theme.spacing(2, 0),
    borderRadius: 8,
  },
  newLabel: {
    background: '#F5F0FF',
    marginLeft: 10,
    fontWeight: 600,
    '& span': {
      fontSize: '11px!important',
      color: '#7B39FF',
    },
  },
}));

export default function SizeGuideSection(props: Props) {
  const {productPageSetting} = props;
  const classes = useStyles();

  const hasProductSizeChartSection = useIsFeatureInTier('PRODUCT_SIZE_CHART');

  const saveSizeChartSuccess = useSelector(
    (state: RootState) => state.productPage.saveSizeChartSuccess
  );
  const saveSizeChartError = useSelector(
    (state: RootState) => state.productPage.saveSizeChartError
  );

  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const [sizeGuideCharts, setSizeGuideCharts] = useState<SizeChart[]>([]);
  const [editChartId, setEditChartId] = useState<string | typeof undefined>();
  // const [enabled, setEnabled] = useState<boolean>(false);

  /*   const handleEnableChange = e => {
    saveProductPageSetting({
      productPageSettingRequest: {
        storeSizeChartSetting: {
          enabled: e.target.checked,
        },
      },
    });
  }; */

  /* const buildSwitchControl = () => {
    return (
      <>
        {!hasProductSizeChartSection && (
          <Chip label="PRO+" size="small" className={classes.newLabel} />
        )}
        <FormControlLabel
          control={
            <IosSwitch
              name="enabledLiveViews"
              checked={enabled}
              disabled={!!disabled || !hasProductSizeChartSection}
              onChange={handleEnableChange}
            />
          }
          labelPlacement="start"
          label={
            <div className={classes.label}>
              {enabled ? 'Activado' : 'Desactivado'}
            </div>
          }
        />
      </>
    );
  }; */

  const chartToEdit = editChartId
    ? sizeGuideCharts.find(c => c.id === editChartId)
    : undefined;

  const handleEditChart = useCallback((id: string) => {
    setEditChartId(id);
  }, []);

  useEffect(() => {
    if (productPageSetting && productPageSetting.storeSizeChartSetting) {
      const {storeSizeChartSetting} = productPageSetting;
      if (storeSizeChartSetting) {
        const {sizeCharts} = storeSizeChartSetting;
        // setEnabled(storeSizeChartSetting.enabled);
        setSizeGuideCharts(sizeCharts);
      }
    }
  }, [productPageSetting]);

  useEffect(() => {
    if (saveSizeChartSuccess) {
      setIsOpenModal(false);
      setEditChartId();
    }
  }, [saveSizeChartSuccess]);

  return (
    <div>
      {saveSizeChartSuccess && (
        <SnackBar mode="success" message="Guardado exitosamente" />
      )}
      {saveSizeChartError && chartToEdit && (
        <SnackBar
          mode="error"
          message="Hubo un error al actualizar la guía de tallas."
        />
      )}
      <Section title="Guia de tallas" /* action={buildSwitchControl()} */>
        <div>
          <Typography className={classes.label}>
            Agrega una guía de tallas o tamaños para ayudar a tus compradores a
            elegir mejor producto y evitar devoluciones
          </Typography>

          <Divider className={classes.divider} />

          <Grid container spacing={2}>
            {sizeGuideCharts.map(chart => (
              <Grid key={chart.id} item xs={12} md={6}>
                <SizeChartItem
                  chart={chart}
                  handleEditChart={handleEditChart}
                />
              </Grid>
            ))}
            <Grid item xs={12}>
              <CustomButton
                disabled={!hasProductSizeChartSection}
                fullWidth
                className={classes.button}
                onClick={() => setIsOpenModal(true)}
              >
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <img src={sizeChartAddIcon} alt="add size chart" />
                  Agregar nueva guía de tallas
                </div>
              </CustomButton>
            </Grid>
          </Grid>
        </div>
      </Section>
      {(isOpenModal || chartToEdit) && (
        <AddNewSizeGuideModal
          open
          handleClose={() => {
            if (!chartToEdit) setIsOpenModal(false);
            else setEditChartId();
          }}
          chartToEdit={chartToEdit}
        />
      )}
    </div>
  );
}
